import React, { FC } from 'react';
import { useHistory } from 'react-router-dom';
import { Box } from '@material-ui/core';
import MentorCard from '../../components/mentor-card';
import BookMentorCallCard from '../../components/book-mentor-call-card';
import { useStyles } from './styles';
import { IMentor } from '../../../types';
import { useAppDispatch } from '../../../store';
import { addMentor } from '../../../store/common';

interface MentorListProps {
  recommendedMentorsList: IMentor[];
  notRecommendedMentorsList: IMentor[];
  showLotteryCard?: boolean;
  loading?: boolean;
}

const MentorList: FC<MentorListProps> = ({
  recommendedMentorsList,
  notRecommendedMentorsList,
  showLotteryCard,
  loading,
}) => {
  const classes = useStyles();
  const history = useHistory();
  const dispatch = useAppDispatch();

  const onMentor = (mentor: IMentor) => {
    dispatch(addMentor({ mentor }));

    history.replace({
      pathname: window.location.pathname,
      search: `mentorId=${mentor.id.toString()}`,
    });
  };

  const adjustedMargin = recommendedMentorsList?.length > 0 ? 42 : 0;

  return (
    <Box className={classes.mentorsSection}>
      {recommendedMentorsList.map((mentor: any) => (
        <Box key={mentor.id} className={classes.item}>
          <MentorCard mentor={mentor} onMentor={onMentor} loading={loading} />
        </Box>
      ))}

      {showLotteryCard && (
        <Box className={classes.item} style={{ marginTop: adjustedMargin }}>
          <BookMentorCallCard loading={loading} />
        </Box>
      )}

      {notRecommendedMentorsList.map((mentor: any) => (
        <Box
          key={mentor.id}
          className={classes.item}
          style={{ marginTop: adjustedMargin }}
        >
          <MentorCard mentor={mentor} onMentor={onMentor} loading={loading} />
        </Box>
      ))}
    </Box>
  );
};

export default MentorList;
